let footer_buttons = document.querySelectorAll('.footer-collapser button');

footer_buttons.forEach(footer_button => {
  footer_button.addEventListener('click', event => {
    let target = event.currentTarget;

    target.parentElement.classList.toggle('collapsed');
    target.classList.toggle('collapsed');
  });
});